import { alpha } from "@mui/material";

export const styles = {
  appToastAlert: (theme) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    boxShadow: `0px 8px 24px ${alpha(theme.palette.common.black, 0.12)}`,
    borderRadius: 2,
    p: 1,
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    "& .MuiAlert-icon": {
    },
    "& .MuiAlert-action": {
      color: theme.palette.common.black,
      pt: 0,
      pb: 0,
    },
  })
}